import { render } from "./Past7.vue?vue&type=template&id=5d784a0a"
import script from "./Past7.vue?vue&type=script&lang=js"
export * from "./Past7.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__